module.exports = __webpack_public_path__ + "static/img/pc端logo.70dcf27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/pc端logo.png
// module id = 40YV
// module chunks = 1